module.exports = __webpack_public_path__ + "img/40_69_007_050.743ed709.jpg";